import { useMutation } from "@tanstack/react-query"
import { useCallback } from "react"
import { cloneAssessmentFetch } from "store/middlewares/assessment.crud"


const useCloneAssessment = () => {
    const { mutateAsync: cloneAssessment } = useMutation({
        mutationFn: cloneAssessmentFetch
    })

    const cloneAss = useCallback((assessmentId) => {
        cloneAssessment(assessmentId)
    }, [])

    return cloneAss
}

export default useCloneAssessment